export const CONTRACT_ADMIN_ROLE_ID = 1;
export const CONTRACT_FINANCE_USER_TYPE_ID =5;
export const CONTRACT_TECHNICAL_USER_TYPE_ID = 6;
